import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { messageActions } from "../store/store";

export default function Loading() {
  const loadingArray = useSelector((state) => state.loading.loadingArray);
  const message = useSelector((state) => state.message);
  const dispatch = useDispatch();
  // snackbar管理
  const [open, setOpen] = useState(false);
  const [queue, setQueue] = useState([]); // { key, type, text }[]
  const [current, setCurrent] = useState(null); // 今表示中のメッセージ

  // 新着メッセージをキューへ
  useEffect(() => {
    if (loadingArray.length !== 0) return;
    if (!message?.message) return;

    const item = {
      key: `${Date.now()}-${Math.random()}`,
      type: message.type,
      text: message.message,
    };
    setQueue((q) => [...q, item]);

    dispatch(messageActions.remove());
  }, [loadingArray, message, dispatch]);

  // 次を開く
  const processQueue = () => {
    setQueue((q) => {
      if (q.length > 0) {
        const [next, ...rest] = q;
        setCurrent(next);
        setOpen(true);
        return rest;
      }
      return q;
    });
  };

  // 初回・または閉じ切った後に次を開く
  useEffect(() => {
    if (!open && !current && queue.length > 0) {
      processQueue();
    }
  }, [open, current, queue]);

  // 閉じる
  const handleClose = (_e, _reason) => {
    setOpen(false);
  };

  // snackbarが閉じた後の処理
  const handleExited = () => {
    setCurrent(null);
    processQueue();
  };
  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) =>
            Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
        }}
        open={loadingArray.length !== 0}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        key={current?.key}
        anchorOrigin={
          current?.type === "error"
            ? { vertical: "top", horizontal: "center" }
            : { vertical: "bottom", horizontal: "left" }
        }
        open={open}
        onClose={handleClose}
        autoHideDuration={6000}
        TransitionProps={{ onExited: handleExited }}
        sx={{ whiteSpace: "pre-wrap" }}
      >
        <Alert
          severity={current?.type === "error" ? "error" : "success"}
          variant="filled"
        >
          {current?.text}
        </Alert>
      </Snackbar>
    </div>
  );
}
